import {
  View,
  StatusBar,
  TouchableOpacity,
  Image,
  Platform,
  Text,
  Keyboard,
  Pressable,
  TextInput,
  KeyboardAvoidingView,
  Alert,
  BackHandler,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import {
  SafeAreaView,
  useSafeAreaInsets,
} from "react-native-safe-area-context";

import EvilIcons from "@expo/vector-icons/EvilIcons";
import { Colors } from "../../../globalStyles/ColorConfig";
import AuthIcons from "../../../assets/Icons/AuthIcons";
import { styles } from "../auth.style";
import TopIconView from "../components/TopIconView";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import dimensions from "../../../globalStyles/dimensions";
import BottomView from "../../../components/GlobalComponents/BottomView";
import SelectCountry from "../../../modal/AuthModals/SelectCountry";
import { registerPhone } from "../../../services/Auth/authService";

type MobileAuthProps = {
  route: any;
};

type RegisterPhoneRequestData = {
  phone: string;
  countryCode: string;
  email?: string;
};

const MobileAuth = ({ route, navigation }: { route: any; navigation: any }) => {
  // const navigation = useNavigation();
  // const { navigation } = route.params

  const [countryCode, setCountryCode] = useState({
    code: "+66",
    uri: "🇹🇭",
    iso: 'TH'
  });
  const [number, setNumber] = useState("");
  const [isCountryModalVisible, setCountryModalVisible] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [errorText, setErrorText]= useState('')

  const inputRef = useRef<TextInput>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const demo = () => {
    // console.log('demo');
  };

  const handleMobileChange = (text: string) => {
    setMobileError(false);
    setNumber(text);
  };

  const toggleCountryModal = () => {
    setCountryModalVisible(!isCountryModalVisible);
  };

  const handleSelectCountry = (
    selectedCountryCode: string,
    selectedCountryUri: string,
    selectedCountryISO: string
  ) => {
    setCountryCode({
      code: selectedCountryCode,
      uri: selectedCountryUri,
      iso: selectedCountryISO
    });
    setCountryModalVisible(false);
  };

  // ------- Testing ready handler function -------

  // const handlePhoneRegister = async () => {
  //   let requestData: RegisterPhoneRequestData;
  //   if (route?.params?.mail) {
  //     requestData = {
  //       phone: number,
  //       countryCode: countryCode.code,
  //       email: route.params.mail,
  //     };
  //   } else {
  //     requestData = {
  //       phone: number,
  //       countryCode: countryCode.code,
  //     };
  //   }
  //   navigation.navigate("auth-otp", { number, countryCode });
  // };

  // --------- production ready handler function ----------

  const handlePhoneRegister = async () => {
    let requestData: RegisterPhoneRequestData;
    if (route?.params?.mail) {
      requestData = {
        phone: number,
        countryCode: countryCode?.code,
        email: route?.params?.mail,
      };
    } else {
      requestData = {
        phone: number,
        countryCode: countryCode?.code,
      };
    }
    try{
      const response = await registerPhone(requestData);
      if ( response && (response?.status === 200 || response?.status === 201)) {
        navigation.navigate("auth-otp", {
          number,
          countryCode,
          email: route?.params?.mail,
        });
      }
    }catch(error){
      console.log("error on Phone Registering: ", error)
      setErrorText("Couldn't send otp to phone")
      setMobileError(true)
    }
  };

  const insets = useSafeAreaInsets();

  const inputStyle =
    Platform.OS === "web" ? { paddingLeft: 10, width: "60%" } : null;

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: Colors.white000,
        paddingTop: Platform.OS === "web" ? 30 : insets.top * 1.6,
      }}
    >
      <StatusBar barStyle="dark-content" backgroundColor={"transparent"} />
      <Pressable onPress={Keyboard.dismiss} style={{ flex: 1 }}>
        <View style={styles.mobileAuthView}>
          <TopIconView icon={<AuthIcons.MobileIconDark />} />
          <CustomComponent.TextView
            title="Let’s get started! What's your phone number? "
            textStyle={[
              GlobalStyles.heading3,
              {
                fontFamily: "EBGaramondSemiBold",
                fontSize: 34,
                lineHeight: 37,
                letterSpacing: -0.3,
              },
            ]}
          />
          {/* <CustomComponent.TextView
            title="We protect our community by making sure everyone on Spark is real"
            textStyle={[
              GlobalStyles.bodyText,
              {
                color: "#ACABAB",
                fontSize: 16,
                fontFamily: "InterMedium",
                opacity: 0.8,
                lineHeight: 20,
                letterSpacing: -0.3,
              },
            ]}
          /> */}
          <View
            style={{
              flexDirection: "row",
              gap: 10,
              width: "100%",
              marginTop: 16,
            }}
          >
            <TouchableOpacity
              onPress={toggleCountryModal}
              style={{
                height: 50,
                backgroundColor: "#EEE",
                borderRadius: 8,
                justifyContent: "center",
                gap: 2,
                alignItems: "center",
                flexDirection: "row",
                paddingHorizontal: 6,
              }}
            >
              <Text style={{ fontSize: 24 }}>{countryCode?.uri}</Text>
              <CustomComponent.TextView
                title={`${countryCode.code}`}
                textStyle={[GlobalStyles.bodyText]}
              />
              <EvilIcons name="chevron-down" size={24} />
            </TouchableOpacity>
            <CustomComponent.InputField
              error={mobileError}
              ref={inputRef}
              placeholder="Enter your number"
              keyboardtype="numeric"
              // maxLength={10}
              onTextChange={handleMobileChange}
              InputStyle={[GlobalStyles.title2, inputStyle]}
            />
          </View>
          {mobileError && errorText && (
            <Text
              style={[
                GlobalStyles.captionText,
                {
                  color: Colors.red10,
                  fontFamily: "InterMedium",
                  letterSpacing: -0.16,
                },
              ]}
            >
              {errorText}
            </Text>
          )}
        </View>
        <BottomView
          enableTitle={true}
          onPress={() => handlePhoneRegister()}
          disableBtn={true}
          bottomTitle="We never share this with anyone and it won’t be on your profile"
          style={{ paddingBottom: 20 }}
        />
      </Pressable>
      {isCountryModalVisible && (
        <SelectCountry
          isVisible={isCountryModalVisible}
          toggleModal={toggleCountryModal}
          method1={demo}
          method2={toggleCountryModal}
          onSelectCountry={handleSelectCountry}
        />
      )}
    </View>
  );
};
export default MobileAuth;
